import * as React from 'react';
import { DatePicker, Form } from 'antd';

// A project's Start Date / End Date pair (projects-v2). Either one on its own is a
// valid project — a workstream with a deadline and no kick-off date is as real as one
// with a start and no fixed end — so neither field is individually required; what is
// required is that at least one of them is set. Both are Option[DateTime] on the
// backend, so this is purely a form rule.
//
// Shared by the create and edit forms so the rule, the labels and the ordering check
// stay identical in both.

const AT_LEAST_ONE_MESSAGE = 'Set a start date, an end date, or both.';

// Both fields carry the "at least one" rule so the error appears under whichever one
// the user is looking at, and each depends on the other so clearing one re-runs the
// check on its partner instead of leaving a stale error behind.
const atLeastOneDateRule = ({ getFieldValue }) => ({
	validator: () =>
		getFieldValue('startDate') || getFieldValue('endDate')
			? Promise.resolve()
			: Promise.reject(new Error(AT_LEAST_ONE_MESSAGE)),
});

const endNotBeforeStartRule = ({ getFieldValue }) => ({
	validator: (_, value) => {
		const startDate = getFieldValue('startDate');
		return value && startDate && value.isBefore(startDate, 'day')
			? Promise.reject(new Error('End date cannot be before the start date.'))
			: Promise.resolve();
	},
});

const ProjectDateRangeFields = () => (
	<div className="flex max-w-[640px] gap-m">
		<Form.Item
			label="Start Date"
			name="startDate"
			className="flex-1"
			dependencies={['endDate']}
			rules={[atLeastOneDateRule]}
		>
			<DatePicker style={{ width: '100%' }} format="MMM D, YYYY" />
		</Form.Item>
		<Form.Item
			label="End Date"
			name="endDate"
			className="flex-1"
			dependencies={['startDate']}
			rules={[atLeastOneDateRule, endNotBeforeStartRule]}
		>
			<DatePicker style={{ width: '100%' }} format="MMM D, YYYY" />
		</Form.Item>
	</div>
);

export default ProjectDateRangeFields;
